module.exports = __webpack_public_path__ + "media/images/favicon/secondary/apple-icon-76x76-58cb6ed52a042badebdb48f49d9d18a5.png";